import {
  Box,
  Button,
  Container,
  Flex,
  Image,
  Text,
  Title,
  Anchor,
  Transition,
} from "@mantine/core";
import React, { useEffect } from "react";
import { useNavigate, useBlocker } from "react-router-dom";
import Main_Logo from "../../assets/logo/Logo.svg";
import GRADIENT from "../../assets/logo/Gradient.png";
import Travel_Trivia from "../../assets/logo/travel-trivia.svg";
import Travel_Survey from "../../assets/logo/travel-survey.svg";
import AMAZON_CARD from "../../assets/logo/amazon-card.svg";
import UPTO from "../../assets/logo/upto.svg";
import { AwesomeButton } from "react-awesome-button";
import "./start.css";
import TajMahal from "../../assets/logo/TajMahal.svg";
// import IndiaGate from "../../assets/logo/India_Gate.svg";
import GatewayOfIndia from "../../assets/logo/Gateway_of_India.svg";
import NachiFalls from "../../assets/logo/nachi_falls.svg";
import Liberty from "../../assets/logo/statue_of_liberty.svg";
import Colosseum from "../../assets/logo/colosseum.svg";
import Petronas from "../../assets/logo/petronas.svg";
import { easeIn, motion } from "framer-motion";
import { customButtonStyles } from "../../customButtonStyles";

const Start = () => {
  const navigate = useNavigate();

  const navigateOnButtonPress = () => {
    navigate("/survey");
  };

  function handleClick() {
    if (navigator.share) {
      navigator
        .share({
          title: "Share Survey",
          text: "Check out this Survey!",
          url: "https://dreamcatcherz-survey.vercel.app/",
        })
        .then(() => console.log("Shared successfully"))
        .catch((error) => console.error("Error sharing:", error));
    } else {
      // Fallback for browsers that do not support Web Share API
      alert("Web Share API is not supported on this browser");
    }
  }

  useEffect(() => {
    // Apply the styles if found
    if (customButtonStyles) {
      const styleTag = document.createElement("style");
      styleTag.innerHTML = customButtonStyles;
      document.head.appendChild(styleTag);
    }
  }, []); // Run only once on component mount

  return (
    <>
      <Flex
        className="main-container"
        flex={1}
        align="center"
        justify="space-evenly"
        py={16}
        px={24}
        gap={16}
        w={"100%"}
        maw={400}
        direction="column"
        style={{
          backgroundImage: "linear-gradient(to bottom, #006C85, #00323D)",
        }}
      >
        <Box
          w={"100vw"}
          h={"100%"}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            overflow: "hidden",
            zIndex: 0,
            // border: "2px solid red",
          }}
        >
          <motion.div
            animate={{ x: -60, y: 4, rotate: -4 }}
            transition={{ ease: "easeInOut", duration: 1, delay: 1 }}
            style={{
              position: "absolute",
              top: 0,
              bottom: 0,
              right: -110,
              // border: "2px solid red",
              // overflow: "hidden",
            }}
          >
            <Image src={Petronas} alt="Petronas" w={150} />
          </motion.div>
          <motion.div
            animate={{ x: 80, y: -40, rotate: -40 }}
            transition={{ ease: "easeInOut", duration: 1, delay: 1 }}
            style={{
              position: "absolute",
              top: 100,
              left: -150,
            }}
          >
            <Image src={Colosseum} alt="Colosseum" w={150} />
          </motion.div>
          <motion.div
            animate={{ x: 90, y: 10, rotate: 6 }}
            transition={{ ease: "easeInOut", duration: 1, delay: 1 }}
            style={{
              position: "absolute",
              top: 250,
              left: -150,
            }}
          >
            <Image src={NachiFalls} alt="NachiFalls" w={150} />
          </motion.div>
          <motion.div
            animate={{ x: -50, y: 10, rotate: -10 }}
            transition={{ ease: "easeInOut", duration: 1, delay: 1 }}
            style={{
              position: "absolute",
              top: 240,
              right: -130,
            }}
          >
            <Image src={Liberty} alt="Liberty" w={150} />
          </motion.div>
          <motion.div
            animate={{ x: -70, y: -50, rotate: -20 }}
            transition={{ ease: "easeInOut", duration: 1, delay: 1 }}
            style={{
              position: "absolute",
              // top: 10,
              right: -100,
              bottom: -50,
            }}
          >
            <Image src={GatewayOfIndia} alt="GatewayOfIndia" w={150} />
          </motion.div>
          <motion.div
            animate={{ x: 60, y: -10, rotate: 20 }}
            transition={{ ease: "easeInOut", duration: 1, delay: 1 }}
            style={{
              position: "absolute",
              // top: 120,
              left: -120,
              bottom: 0,
            }}
          >
            <Image src={TajMahal} alt="Taj Mahal logo" w={150} />
          </motion.div>
        </Box>
        <Flex
          direction="column"
          align="center"
          justify="space-around"
          flex={2}
          style={{ zIndex: 1 }}
          w={"100%"}
        >
          <Anchor
            href="https://www.dreamcatcherz.net/"
            target="_blank"
            style={{
              width: "80%",
              height: "auto",
            }}
          >
            <Image src={Main_Logo} style={{ height: "auto" }} align="center" />
          </Anchor>
          <Image src={Travel_Survey} className="trivia-title" w={300} mt={10} />
          <Flex
            direction="column"
            align="center"
            style={{ zIndex: 1 }}
            w={"100%"}
          >
            <Title order={4} align="center" c="#f7f7f7" mt={20}>
              Answer questions to claim
            </Title>
            <Title order={4} align="center" c="#f7f7f7">
              Amazon Gift Vouchers upto ₹100/-
            </Title>
            <Image src={AMAZON_CARD} h={170} w={170} />
          </Flex>
        </Flex>

        <Flex
          direction="column"
          align="center"
          justify="center"
          w={"100%"}
          flex={1}
          style={{ zIndex: 1 }}
        >
          <AwesomeButton
            className="custom-awesome-button"
            onPress={navigateOnButtonPress}
            style={{ width: "100%" }}
            // style={{ width: "60%" }}
          >
            <Title
              order={4}
              c="#004251"
              // style={{ border: "1px solid green" }}
              w={"150"}
            >
              Start Survey
            </Title>
          </AwesomeButton>
          <Text
            c="#d4dc64"
            td="underline"
            size="md"
            mt={16}
            style={{ cursor: "pointer" }}
            onClick={handleClick}
          >
            Share survey with friends
          </Text>
        </Flex>
      </Flex>
    </>
  );
};

export default Start;
